import { render } from "./SubscribeChainTab.vue?vue&type=template&id=2c202782"
import script from "./SubscribeChainTab.vue?vue&type=script&lang=js"
export * from "./SubscribeChainTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__